import { useState, useCallback, useEffect, useMemo } from 'react';
import { useApi } from '../hooks/api';
import { Service } from '../types/theme';
import moment from 'moment';

export const useStations = () => {
  const [circulationDate, setCirculationDate] = useState(moment());
  const [services, setServices] = useState<Service[]>([]);
  const [selectedServiceName, setSelectedServiceName] = useState('');
  const { getServicesByDate } = useApi();

  const serviceNames = useMemo(() => services.map((service) => service.serviceName), [services]);
  const stationOptions = useMemo(() => {
    const serviceFound = services.find((service) => service.serviceName === selectedServiceName);
    if (serviceFound) {
      return serviceFound.stations.map((station) => ({
        label: station.name,
        value: station.uicStationCode,
      }));
    }
    return [];
  }, [services, selectedServiceName]);

  const handleOnDateChange = useCallback((date) => {
    setCirculationDate(moment(date));
  }, []);

  const handleServiceNameChange = useCallback((serviceName) => {
    setSelectedServiceName(serviceName);
  }, []);

  const getStations = useCallback(
    async (circulationDate) => {
      try {
        const date = moment(circulationDate).format('YYYY-MM-DD');
        const response = await getServicesByDate(date);
        setServices(response || []);
      } catch (error) {}
    },
    [getServicesByDate]
  );

  useEffect(() => {
    getStations(circulationDate);
  }, [getStations, circulationDate]);

  return { handleOnDateChange, serviceNames, handleServiceNameChange, stationOptions, getStations };
};
